<template>
  <abk-offer-invitations-list offer-invitations-type="current"/>
</template>

<script>
import AbkOfferInvitationsList from '../../../components/offer_invitations/AbkOfferInvitationsList'

export default {
  name: 'OfferInvitationsCurrentTab',
  components: { AbkOfferInvitationsList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.offer_invitations.list_tabs.current.title'),
        subtitle: this.$t('views.offer_invitations.list_tabs.current.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>
